/* PEAK PDP gallery affordance (austin-cc, 2026-10-01). Styles: assets/pkj-pdp-gallery.css.
   Phones: "1 / N" counter pill on the photo; it follows swipes, dot taps and keyboard.
   Desktop: previous / next buttons (44px, SVG chevrons) over the main photo, shown on hover or focus.
   Both: names for the pager dots ("Show photo 3 of 16") and a polite live line ("Photo 3 of 16").
   Uses the theme's own carousel (carousel-component.embla); falls back to the dots' is-primary class.
   Only on the PEAK sauna templates (.pkj-purchase-anchor). Event: pk_pdp_gallery_nav once per page. */
(function () {
  if (window.__pkjGallery) return; window.__pkjGallery = 1;
  var CHEV = { prev: 'M15 5l-7 7 7 7', next: 'M9 5l7 7-7 7' };
  var tracked = false;
  function track(via, n) {
    if (tracked) return; tracked = true;
    try { if (window.PK && typeof PK.track === 'function') PK.track('pk_pdp_gallery_nav', { pk_via: via, pk_photos: n }); } catch (e) {}
  }
  function svg(d) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function setup(root, kind) {
    var cc = root.querySelector('carousel-component[data-product-media-carousel-component]');
    if (!cc || cc.__pkjGal) return; cc.__pkjGal = 1;
    var slides = cc.querySelectorAll('[data-container="carousel"] > .carousel__slide');
    var n = slides.length; if (n < 2) return;
    var vp = cc.querySelector('[data-carousel-viewport]');
    if (!vp) return;
    if (!vp.id) vp.id = 'pkj-gal-vp-' + kind;
    /* Counter and buttons sit in the carousel box; --pkj-gal-vp-h (photo frame height) places them on the photo. */
    var vph = function () { cc.style.setProperty('--pkj-gal-vp-h', vp.offsetHeight + 'px'); };
    vph();
    if ('ResizeObserver' in window) new ResizeObserver(vph).observe(vp); else window.addEventListener('resize', vph, { passive: true });
    var dots = cc.querySelectorAll('[data-carousel-dot]');
    var last = -1, via = null, count = null, prev = null, next = null;

    var live = document.createElement('span');
    live.className = 'pkj-gal-sr'; live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true');
    cc.appendChild(live);

    if (kind === 'm') {
      count = document.createElement('span');
      count.className = 'pkj-gal-count'; count.setAttribute('aria-hidden', 'true'); count.textContent = '1 / ' + n;
      cc.appendChild(count);
      var bleed = function () {
        var r = root.getBoundingClientRect(), w = document.documentElement.clientWidth;
        var b = Math.round(w - r.right);
        if (b >= 0 && b <= 40) root.style.setProperty('--pkj-gal-bleed', b + 'px');
      };
      bleed(); window.addEventListener('resize', bleed, { passive: true });
      root.addEventListener('touchstart', function () { via = 'swipe'; }, { passive: true });
    } else {
      var mk = function (dir, label) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pkj-gal-nav pkj-gal-nav--' + dir;
        b.setAttribute('aria-label', label); b.setAttribute('aria-controls', vp.id);
        b.innerHTML = svg(CHEV[dir]);
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var em = cc.embla; via = 'arrow';
          if (em) { dir === 'prev' ? em.scrollPrev() : em.scrollNext(); }
          else { var i = cur(); var d = dots[dir === 'prev' ? i - 1 : i + 1]; if (d) d.click(); }
        });
        cc.appendChild(b); return b;
      };
      prev = mk('prev', 'Previous photo'); next = mk('next', 'Next photo');
      root.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || !e.target.closest('.pkj-gal-nav')) via = 'drag'; }, { passive: true });
    }

    /* Pager dots: accessible names, Enter / Space work like a tap. */
    Array.prototype.forEach.call(dots, function (d, i) {
      if (!d.getAttribute('aria-label')) d.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + n);
      if (!d.getAttribute('role')) d.setAttribute('role', 'button');
      d.addEventListener('click', function () { via = 'dot'; });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); via = 'dot'; d.click(); }
      });
    });

    function cur() {
      var em = cc.embla;
      if (em && typeof em.selectedScrollSnap === 'function') {
        var s = em.selectedScrollSnap(), snaps = em.scrollSnapList().length;
        return (snaps < n && s === snaps - 1) ? n - 1 : s;   /* trimmed last snap = last photo */
      }
      for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('is-primary')) return i;
      return 0;
    }
    function render() {
      var i = Math.max(0, Math.min(n - 1, cur()));
      if (count) count.textContent = (i + 1) + ' / ' + n;
      if (prev) {
        var em = cc.embla;
        prev.disabled = em ? !em.canScrollPrev() : i === 0;
        next.disabled = em ? !em.canScrollNext() : i === n - 1;
      }
      if (last !== -1 && i !== last) { live.textContent = 'Photo ' + (i + 1) + ' of ' + n; track(via || 'other', n); }
      last = i;
    }
    var bound = null;
    function bind() {
      var em = cc.embla;
      if (em && em !== bound && typeof em.on === 'function') { bound = em; em.on('select', render); em.on('reInit', render); }
      render();
    }
    bind();
    /* The carousel may start (or restart) after this script: re-bind for a few seconds, then on resize. */
    var tries = 0, iv = setInterval(function () { bind(); if (++tries > 25) clearInterval(iv); }, 200);
    window.addEventListener('resize', function () { setTimeout(bind, 250); }, { passive: true });
    /* Fallback: the theme marks the current dot with is-primary. */
    if (dots.length && 'MutationObserver' in window) {
      new MutationObserver(render).observe(dots[0].parentNode, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }
  function init() {
    if (!document.querySelector('.pkj-purchase-anchor')) return;
    var m = document.querySelector('.product-mobile-media'), d = document.querySelector('.product-desktop-media');
    if (m) setup(m, 'm');
    if (d) setup(d, 'd');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
